import * as R from 'ramda';
import { TopLevelSpecification } from '../../../../levels/TopLevelSpecification';

export const hasAnyTopLevelSpecificationWithUnsetRealBuiltSurface = (
  levels: TopLevelSpecification[]
): boolean => R.any((level: TopLevelSpecification) => R.isNil(level.realBuiltSurface))(levels);
